<template>
  <div>
    <label :for="meta.id" style="font-size: 15px">{{ meta.label }}</label>
    <pwc-uploader
      :id="meta.id"
      style="margin-top:10px"
      :options="{key: meta.id, type: 'file'}"
      :hasfile-list="flieList"
      @uploadOrDelete="(val) => {uploadOrDelete(val, meta)}"
      @uploaded="(val) => {uploaded(val, meta)}"
    />
    <span class="error-msg" :class="validate ? 'active': ''">请选择文件</span>
  </div>
</template>
<script>
import PwcUploader from '@/components/PwcUpload'
export default {
  components: {
    PwcUploader
  },
  props: {
    meta: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    },
    flieList: {
      type: Array,
      default: () => []
    },
    validate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      myValue: this.value
    }
  },
  watch: {
    value(newVal) {
      this.myValue = newVal
    }
  },
  methods: {
    uploadOrDelete(newVal, meta) {
      this.$emit('uploadOrDelete', newVal)
    },
    uploaded(newFileList, meta) {
      this.$emit('uploaded', newFileList)
    }
  }
}
</script>

<style>

</style>
